import React, { useEffect } from "react";
import { BasicsInfoStyled } from "./basic-info.style";
import UserInfoForm, {
  USER_INFO_FORM_VIEW_TYPES,
} from "../../users-info-form";

const BasicInfo = ({ userData, isEditMode, form }) => {
  const { isDirty } = form.formState;
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isEditMode && isDirty) {
        const message = "Hold on! Your changes have not been saved.";
        event.returnValue = message;
        return message;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isEditMode, isDirty]);
  console.log("BasicInfo userData:", userData);

  return (
    <BasicsInfoStyled>
      <div
        className="user-form"
        style={{
          pointerEvents: isEditMode ? "" : "none",
          opacity: isEditMode ? "1.0" : "0.7",
        }}
      >
        <UserInfoForm
          userData={userData}
          form={form}
          view={USER_INFO_FORM_VIEW_TYPES.detail}
        />
      </div>
    </BasicsInfoStyled>
  );
};

export default BasicInfo;
